import { UploadResumesProcessedCandidatesComponent } from "./upload-resumes-processed-candidates.component";
import { UploadResumesProcessedCandidatesModalComponent } from "./uploadResumesProcessedCandidatesModal/upload-resumes-processed-candidates-modal.component";
export var UploadResumesProcessedCandidatesModule = angular
    .module('uploadResumesProcessedCandidates', [])
    .component(UploadResumesProcessedCandidatesComponent.selector, UploadResumesProcessedCandidatesComponent.component)
    .component(UploadResumesProcessedCandidatesModalComponent.selector, UploadResumesProcessedCandidatesModalComponent.component)
    .name;
//# sourceMappingURL=upload-resumes-processed-candidates.module.js.map